'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function NameValueItem(_a) {
    var name = _a.name, value = _a.value, _b = _a.itemClassName, itemClassName = _b === void 0 ? '' : _b, _c = _a.nameClassName, nameClassName = _c === void 0 ? '' : _c, _d = _a.valueClassName, valueClassName = _d === void 0 ? '' : _d;
    if (!value) {
        return null;
    }
    return (React.createElement("span", { className: "name-value-item " + itemClassName },
        name && name !== '' && (React.createElement("span", { className: "name " + nameClassName },
            name,
            "\u00A0")),
        React.createElement("span", { className: "value " + valueClassName }, value)));
}

function TimestampFormatter(props) {
    var timestamp = props.timestamp, _a = props.prefix, prefix = _a === void 0 ? '' : _a, _b = props.locale, locale = _b === void 0 ? 'de' : _b;
    if (timestamp) {
        var dateTimeFormatter = new Intl.DateTimeFormat(locale + '-CH', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
        });
        var date = new Date(timestamp * 1000);
        return (React.createElement(NameValueItem, __assign({}, props, { name: prefix, value: dateTimeFormatter.format(date) })));
    }
    else {
        return null;
    }
}

function VersionFormatter(props) {
    var version = props.version, _a = props.prefix, prefix = _a === void 0 ? 'Version' : _a;
    if (version) {
        return React.createElement(NameValueItem, __assign({}, props, { name: prefix, value: version }));
    }
    else {
        return null;
    }
}

function PublicationInfo(_a) {
    var publicationDate = _a.publicationDate, changeDate = _a.changeDate, version = _a.version, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.itemClassName, itemClassName = _c === void 0 ? '' : _c, _d = _a.nameClassName, nameClassName = _d === void 0 ? '' : _d, _e = _a.valueClassName, valueClassName = _e === void 0 ? '' : _e;
    if (window.project) {
        publicationDate = publicationDate || window.project.publicationDate;
        changeDate = changeDate || window.project.changeDate;
        version = version || window.project.version;
    }
    var itemClasses = {
        itemClassName: itemClassName,
        nameClassName: nameClassName,
        valueClassName: valueClassName
    };
    return (React.createElement("div", { className: "publication-info " + className },
        React.createElement(TimestampFormatter, __assign({ prefix: 'Erstellt: ', timestamp: publicationDate }, itemClasses)),
        React.createElement(TimestampFormatter, __assign({ prefix: 'Letzte \u00C4nderung: ', timestamp: changeDate }, itemClasses)),
        React.createElement(VersionFormatter, __assign({ version: version }, itemClasses))));
}

exports.NameValueItem = NameValueItem;
exports.PublicationInfo = PublicationInfo;
exports.TimestampFormatter = TimestampFormatter;
exports.VersionFormatter = VersionFormatter;
//# sourceMappingURL=index.js.map
